import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2024 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { StyledCountText } from './countTextStyles';
import { visuallyHidden } from '@mui/utils';
export var CountText = function CountText(_ref) {
  var selectedCount = _ref.selectedCount,
    loading = _ref.loading,
    loadingText = _ref.loadingText,
    total = _ref.total,
    tableCollectionString = _ref.tableCollectionString,
    ariaLiveOn = _ref.ariaLiveOn,
    countTextAriaLabel = _ref.countTextAriaLabel;
  var intl = useIntl();
  var isCountTextBeingUsedAsTitle = !!total && total < 0;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    countText = _useState2[0],
    setCountText = _useState2[1];
  useEffect(function () {
    var countText = '';
    if (loading) {
      countText = loadingText !== null && loadingText !== void 0 ? loadingText : intl.formatMessage({
        id: 'embers.table.topControls.loading',
        defaultMessage: 'Finding results...'
      });
    } else {
      if (total) {
        if (total < 0) {
          // count text as title while total < 0
          countText = tableCollectionString !== null && tableCollectionString !== void 0 ? tableCollectionString : '';
        } else {
          if (selectedCount && selectedCount > 0) {
            countText = intl.formatMessage({
              id: 'embers.table.topControls.hasSelected',
              defaultMessage: '{selectedCount} of {total} selected: '
            }, {
              selectedCount: selectedCount,
              total: total
            });
          } else {
            countText = intl.formatMessage({
              id: 'embers.table.topControls.noSelected',
              defaultMessage: '{total} {things}'
            }, {
              total: total.toLocaleString(),
              things: tableCollectionString
            });
          }
        }
      }
    }
    setCountText(countText);
  }, [loading, total, selectedCount, tableCollectionString]);
  return /*#__PURE__*/React.createElement(StyledCountText, {
    className: classnames({
      'EmbersTableTopControls-CountText': !isCountTextBeingUsedAsTitle,
      'EmbersTableTopControls-CountTextAsTitle': isCountTextBeingUsedAsTitle
    })
  }, /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    "aria-hidden": !!countTextAriaLabel
  }, countText), /*#__PURE__*/React.createElement("span", {
    "aria-live": ariaLiveOn ? 'polite' : 'off',
    style: visuallyHidden
  }, countTextAriaLabel));
};